export const TOP_SQL_TREND_COLOR_NAMES = [
  'peacock',
  'green',
  'magenta',
  'aqua',
  'violet',
  'thyme',
  'rosy',
  'airy',
  'sky',
  'purple',
  'mauve',
  'blue',
  'mustard'
] as const

export const TOP_SQL_TREND_COLOR_SHADE = 8
export const TOP_SQL_TREND_COLOR_ALPHA = 0.8
export const TOP_SQL_TREND_COLOR_ALPHAS = [0.8, 0.6, 0.4, 0.2] as const

export function withAlpha(color: string, alpha: number) {
  if (color.startsWith('rgba(')) {
    return color.replace(
      /rgba\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/,
      `rgba($1, $2, $3, ${alpha})`
    )
  }

  if (color.startsWith('rgb(')) {
    return color.replace(
      /rgb\((\d+),\s*(\d+),\s*(\d+)\)/,
      `rgba($1, $2, $3, ${alpha})`
    )
  }

  if (color.startsWith('#') && color.length === 7) {
    const red = Number.parseInt(color.slice(1, 3), 16)
    const green = Number.parseInt(color.slice(3, 5), 16)
    const blue = Number.parseInt(color.slice(5, 7), 16)

    return `rgba(${red}, ${green}, ${blue}, ${alpha})`
  }

  return color
}
